import Request from 'utils/request';
import config from 'config/Config';

export default class {
  // 获取产品列表
  static getProductList(params, data) {
    return Request({
      url: 'es/item/query/browse/page-info',
      host: config.HOST_SEARCH,
      method: 'post_json',
      params,
      data
    });
  }

  // 获取分类列表
  static getCategoryCount(data) {
    return Request({
      url: `progress/learning/categoryCount`,
      method: 'post_json',
      host: config.HOST_PROMOTE,
      data
    });
  }

  // 类目列表
  static getCatalogList(params) {
    return Request({
      url: `item/catalog/tree/children`,
      host: config.HOST_MALL,
      params
    });
  }
  // 课程列表
  static getCourseList(params, url) {
    return Request({
      url,
      host: config.HOST_PROMOTE,
      params
    });
  }

  // 商品浏览任务-向上更新浏览时间 返回更新值
  static eyeTimeUpdate(params) {
    return Request({
      url: 'progress/clock/personal/processTask/eyeTimeUpdate',
      host: config.HOST_PROMOTE,
      method: 'post',
      params
    });
  }

  /**
   * 上报打卡任务
   */
  static finishTaskReport(params) {
    return Request({
      url: `progress/clock/personal/finishTask`,
      host: config.HOST_PROMOTE,
      method: 'post',
      params
      // ignoreErr: true,
    });
  }

  static searchActivityZone(params) {
    return Request({
      url: `promotion/searchActivityZone`,
      host: config.HOST_MALL,
      method: 'post_json',
      data: params
    });
  }

  static searchEnter(params) {
    return Request({
      url: `user/info/searchEnter?searchKeyword=${params.searchKeyword}`,
      host: config.HOST_MALL,
      method: 'get',
      data: params
    });
  }
}



// WEBPACK FOOTER //
// ./src/pages/Shop/Product/ProductList/ProductListServ.js